import React from 'react';
import './DesktopBlockWarning.css';

function DesktopBlockWarning({ onLogout, onBack, showLogout = false }) {
  return (
    <div className="desktop-block-page">
      <div className="desktop-block-card">
        <div className="desktop-block-header">
          <div className="warning-icon">⚠️</div>
          <h1>Ứng dụng chỉ dành cho điện thoại di động</h1>
          <p>Bạn đang truy cập từ máy tính</p>
        </div>

        <div className="desktop-block-content">
          <p className="warning-message">
            Để chấm công, vui lòng mở ứng dụng trên điện thoại di động của bạn.
          </p>
          
          <div className="instruction-box">
            <h3>Hướng dẫn:</h3>
            <ol>
              <li>Mở trình duyệt trên điện thoại</li>
              <li>Truy cập địa chỉ: <code>{window.location.origin}</code></li>
              <li>Đăng nhập và bắt đầu chấm công</li>
            </ol>
          </div>

          {showLogout && onLogout ? (
            <button onClick={onLogout} className="btn-logout-desktop">
              Đăng xuất
            </button>
          ) : onBack ? (
            <button onClick={onBack} className="btn-back-desktop">
              Quay lại
            </button>
          ) : null}

          <div className="admin-note">
            <p>
              <strong>Quản trị viên:</strong> Bạn có thể truy cập trang quản trị trên máy tính.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DesktopBlockWarning;
